import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { userinfoActions, alertActions, regisActions, certificateActions } from '../../../store/actions'
import Pcc from '../../../module/cert/Pcc/PccV4'
import { valid } from '../../../hook/valid'

import Input from '../../../module/input/CustomInput'
import moment from 'moment'
import InactiveBox from './InactiveBox'
import * as common from '../../../assets/js/common.js'
import PccMobile from '../../../module/cert/Pcc/PccV4Mobile'

const ChangeInfo = (props) => {
  const [user, setUser] = useState({})

  const [state, setState] = useState({
    isView: false,
  })

  // 본인인증popup open 여부
  const [isPccOpen, setIsPccOpen] = useState(false)
  const [initMobileNo, setInitMobileNo] = useState('')

  useEffect(() => {
    // 회원정보 조회
    props.load()
    setUser(props?.user?.user?.payload)

    return () => {
      props.setInitialState()
    }
  }, [])

  useEffect(() => {
    setState({
      ...state,
      ...props.userInfo,
    })

    if (props.userInfo !== undefined && props.userInfo.mobileNo !== undefined && initMobileNo === '') {
      console.log(props.userInfo)
      setInitMobileNo(props.userInfo.mobileNo)
    }
  }, [props.userInfo])

  useEffect(() => {
    if (props.isSearch) {
      // LOAD_SUCCESS시 true
      props.userInfo.passwd = '' // 비밀번호 초기화...

      setState({
        ...state,
        ...props.userInfo,
      })
    }
  }, [props.isSearch])

  useEffect(() => {
    if (props.cellNo) {
      // 기존 등록된 휴대폰 번호와 변경된 휴대폰 번호가 다를 때
      if (initMobileNo !== props.cellNo) {
        if (props.user.user.payload.userSeCd === '01') {
          props.checkMobile('01', props.cellNo, props.certCi)
        } else {
          props.checkMobile('02', props.cellNo, props.certCi)
        }
      }

      setState((state) => ({
        ...state,
        mobileNo: props.cellNo,
      }))
    }
  }, [props.cellNo])

  useEffect(() => {
    if (props.certDate) {
      setState((state) => ({
        ...state,
        mobileCertDt: props.certDate,
      }))
    }
  }, [props.certDate])

  useEffect(() => {
    if (props.certCi) {
      setState((state) => ({
        ...state,
        certCi: props.certCi,
      }))
    }
  }, [props.certCi])

  useEffect(() => {
    if (props.certName) {
      setState((state) => ({
        ...state,
        memberName: props.certName,
      }))
    }
  }, [props.certName])

  useEffect(() => {
    if (props.fgnGbn) {
      setState((state) => ({
        ...state,
        nativeYn: props.fgnGbn === '1' ? 'Y' : 'N', // 1-내국인, 2-외국인
      }))
    }
  }, [props.fgnGbn])

  useEffect(() => {
    if (props.sex) {
      setState((state) => ({
        ...state,
        genderCd: props.sex,
      }))
    }
  }, [props.sex])

  useEffect(() => {
    if (props.birYMD) {
      setState((state) => ({
        ...state,
        birthDay: props.birYMD,
      }))
    }
  }, [props.birYMD])

  useEffect(() => {
    if (props.isUpdate) {
      // 사용자정보 변경 성공
      // 회원정보(이메일, 휴대폰, 주소) 수정 Alert 호출
      props.success({
        title: '변경성공',
        message: '성공적으로 변경되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.reload()
          },
        },
      })
    }
  }, [props.isUpdate])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const updateUserInfo = (e) => {
    e.preventDefault()

    const checkObj = {
      userId: state.memberId, // 개인정보 변경 시 인증절차에서 JoinDate를 확인하기위한 param으로 쓰임
      email: state.email,
      mobileNo: state.mobileNo,
      passwd: state.passwd,
      groupDept: state.groupDept,
      groupClsf: state.groupClsf,

      almEmailYn: state.almEmailYn,
      // almPushYn: state.almPushYn,
      almKakaoYn: state.almKakaoYn,
      almSmsYn: state.almSmsYn,
    }

    // MOBILE_NO(휴대폰번호), CERT_CI(인증 CI값) 중복체크
    if (props.checkMobileYn !== null && !props.checkMobileYn) {
      // return props.error({ message: '해당 휴대폰 번호로 가입된 사용자가 존재합니다.' })
      return props.success({
        title: '확인',
        message: '해당 휴대폰 번호로 가입된 사용자가 존재합니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.reload()
          },
          cancelCallback: () => {
            window.location.reload()
          },
        },
      })
    }

    // 기존 본인인증(CI)과 다른 CI 로의 변경 차단은 서버(PUT /user)가 수행한다.
    // 응답 CI 제거로 브라우저는 기존 CI 를 알 수 없으므로 여기서 비교하지 않는다.

    // 유효성 체크
    if (props.checkFindInput(checkObj)) {
      checkObj['certCi'] = state.certCi
      checkObj['memberName'] = state.memberName
      checkObj['nativeYn'] = state.nativeYn
      checkObj['genderCd'] = state.genderCd
      checkObj['birthDay'] = state.birthDay

      console.log('checkObj', checkObj)

      props.confirm({
        title: '확인',
        message: '저장하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.updateUserInfo(checkObj)
          },
        },
      })
    }
  }

  const isViewInactiveBox = (e) => {
    e.preventDefault()
    if (props.checkFindInput({ passwd: state.passwd })) {
      setState({
        ...state,
        isView: !state.isView,
      })
    }
  }

  const checkHandler = (e) => {
    const { id, checked } = e.target

    setState({
      ...state,
      [id]: checked === true ? 'Y' : 'N',
    })
  }

  return (
    <div id="contents">
      {/* <Alert /> */}
      <div className="content-header">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>회원정보 변경 (탈퇴)</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <span>마이페이지</span>
          <em>회원정보 변경 (탈퇴)</em>
        </div>
      </div>
      <div className="tit-wrap">
        <div className="tit-group">
          <h3 className="h3-tit mt0">개인정보 변경</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
        </div>
        <span className="right">
          <Link to="/retire" title="탈퇴하기" className="btn-secondary sm">
            탈퇴하기
          </Link>
        </span>
      </div>
      <table className="tbl-write">
        <caption>아이디, 비밀번호, 이름, 부서 및 직급, 이메일, 휴대폰 번호 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 아이디
            </th>
            <td>
              <span className="inquiry-group">
                <Input
                  inputTitle="아이디"
                  type={'text'}
                  id="memberId"
                  name="memberId"
                  value={state.memberId || ''}
                  required={true}
                  readOnly={true}
                  flow={'right'}
                  placeholder="아이디"
                  wrapperClassWidth="inherit"
                />
              </span>
            </td>
            <th scope="row">
              <em className="required" /> 비밀번호
            </th>
            <td>
              <Input
                inputTitle="비밀번호"
                type={'password'}
                id="passwd"
                name="passwd"
                value=""
                className="form-keyword"
                message={'비밀번호를 입력하세요'}
                required={true}
                numberOnly={false}
                onChange={(e) => handleChange(e)}
                flow={'right'}
                placeholder="비밀번호를 입력하세요."
              />
            </td>
          </tr>
          <tr>
            {/* 회원정보변경 => roleId: 1(사업자/단체 관리자), 2(사업자/단체 사용자), 3(개인) */}
            {user?.roleDto?.roleId === 3 ? (
              <>
                <th scope="row">
                  <em className="required" /> 이름
                </th>
                <td>
                  <Input
                    inputTitle="이름"
                    type={'text'}
                    id="memberName"
                    name="memberName"
                    value={state.memberName || ''}
                    className="form-keyword disabled"
                    required={true}
                    readOnly={true}
                    flow={'right'}
                    placeholder="이름"
                  />
                </td>
              </>
            ) : (
              <>
                <th scope="row">
                  <em /> 부서 및 직급
                </th>
                <td>
                  <span className="input-group">
                    <Input
                      inputTitle="부서명"
                      type={'text'}
                      id="groupDept"
                      name="groupDept"
                      value={state.groupDept || ''}
                      required={false}
                      onChange={(e) => handleChange(e)}
                      flow={'right'}
                      placeholder="부서"
                      wrapperClassWidth="inherit"
                    />
                    <Input
                      inputTitle="직급"
                      type={'text'}
                      id="groupClsf"
                      name="groupClsf"
                      value={state.groupClsf || ''}
                      required={false}
                      onChange={(e) => handleChange(e)}
                      flow={'right'}
                      placeholder="직급"
                      wrapperClassWidth="inherit"
                    />
                  </span>
                </td>
              </>
            )}
            <th scope="row">
              <em className="required" /> 이메일
            </th>
            <td>
              <Input
                inputTitle="이메일"
                type={'text'}
                id="email"
                name="email"
                value={state.email || ''}
                className="form-keyword"
                required={true}
                onChange={(e) => handleChange(e)}
                flow={'right'}
                placeholder="이메일"
              />
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 휴대폰 번호
            </th>
            <td colSpan={3}>
              <span className="inquiry-group" style={{ position: 'relative' }}>
                <Input
                  inputTitle="휴대폰 번호"
                  type={'text'}
                  id="mobileNo"
                  name="mobileNo"
                  value={state.mobileNo || ''}
                  readOnly={true}
                  required={true}
                  withBtn={true}
                  withBtnName="본인인증"
                  regErrMsg="본인인증이 인증되지 않았습니다. 본인인증을 진행해주세요."
                  onChange={(e) => handleChange(e)}
                  withBtnClick={() => setIsPccOpen(true)}
                  flow={'right'}
                  placeholder="본인인증을 진행해주세요."
                  wrapperClassWidth="inherit"
                />
                {common.getDeviceType() !== 'MobileApp' ? (
                  <>
                    <p className="desc" style={{ position: 'absolute', right: '-310px', top: '0px' }}>
                      ※ 휴대폰 번호가 변경 되었을 경우 본인 인증이 필요합니다.
                    </p>
                    <Pcc isPccOpen={isPccOpen} onChange={() => setIsPccOpen(false)} />
                  </>
                ) : (
                  <>
                    <p className="desc" style={{ position: 'absolute', right: '72px', top: '33px' }}>
                      ※ 휴대폰 번호가 변경 되었을 경우 본인 인증이 필요합니다.
                    </p>
                    <PccMobile isPccOpen={isPccOpen} onChange={() => setIsPccOpen(false)} />
                  </>
                )}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3 className="h3-tit">알람 수신 동의 (선택)</h3>
      <div className="check-box">
        <span className="check-group">
          <input title="이메일 수신동의" type="checkbox" id="almEmailYn" checked={state.almEmailYn === 'Y'} onChange={checkHandler} />
          <em />
          <label htmlFor="almEmailYn">E-mail 수신 동의</label>
          <input title="알람톡 수신동의" type="checkbox" id="almKakaoYn" checked={state.almKakaoYn === 'Y'} onChange={checkHandler} />
          <em />
          <label htmlFor="almKakaoYn">알람톡 수신 동의</label>
          <input title="SMS 수신동의" type="checkbox" id="almSmsYn" checked={state.almSmsYn === 'Y'} onChange={checkHandler} />
          <em />
          <label htmlFor="almSmsYn">SMS 수신 동의</label>
        </span>
      </div>
      <p>＊최신 수정일 : {moment(props.userInfo?.modDt).format('YYYY.MM.DD')}</p>
      <div className="btn-block">
        <p style={{ marginBottom: '5px' }}> 
            {props.userInfo?.ewalletId === null || props.userInfo?.ewalletId === undefined ? (
              '＊내 지갑주소'
            ) : (
              state.inatAcntYn == 'N' ? "＊내 지갑주소 : " + props.userInfo?.ewalletId : '＊전자지갑 폐쇄상태'
            )}
        </p>
        <button type="button" className="btn-secondary md" onClick={isViewInactiveBox}>
          전자지갑 {state.inatAcntYn == 'N' ? '폐쇄하기' : '활성화하기'}
        </button>
        <InactiveBox
          passwd={state.passwd}
          isView={state.isView}
          isType={state.inatAcntYn}
          onChange={() =>
            setState({
              ...state,
              isView: !state.isView,
            })
          }
        />
        <span className="right">
          <Link to="/" title="취소" className="btn-secondary md">
            취소
          </Link>
          <button className="btn-primary md" onClick={updateUserInfo}>
            저장
          </button>
        </span>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    userInfo: state.userinfo?.data,
    address: state.userinfo?.address,
    isSearch: state.userinfo?.isSearch,
    isCalled: state.userinfo?.isCalled,
    isUpdate: state.userinfo?.isUpdate,
    cellNo: state.certificate.resultInfo.cellNo,
    certDate: state.certificate.resultInfo.certDate,
    certCi: state.certificate.resultInfo.ci1,
    certName: state.certificate.resultInfo.name,
    fgnGbn: state.certificate.resultInfo.fgnGbn,
    sex: state.certificate.resultInfo.sex,
    birYMD: state.certificate.resultInfo.birYMD,
    checkMobileYn: state.regis.checkMobileYn,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  updateUserInfo: userinfoActions.updateUserInfo,
  // setHomeAddress: userinfoActions.setHomeAddress,
  checkFindInput: valid.checkFindInput,
  confirm: alertActions.confirm,
  success: alertActions.success,
  error: alertActions.error,
  checkMobile: regisActions.checkMobile,
  setInitialState: certificateActions.setInitialState,
}

export default connect(mapStateToProps, actionCreators)(ChangeInfo)
